import React, { useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, useLocation } from 'react-router-dom';
import getPlainRoutes from './routes';
import * as firebase from 'firebase/app';
import { config } from './firebase/firebaseConfigs';
import { FirestoreProvider } from '@react-firebase/firestore';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { logEvent } from './firebase/firebaseAnalytics';

export default function App() {
	const location = useLocation();

	useEffect(() => {
		logEvent('page_view', {
			page_location: window.location.href,
			debug_mode: 1,
		});
	}, [location.pathname, location.search]);

	return (
		<FirestoreProvider firebase={firebase} {...config}>
			<Router>
				<ScrollToTop />
				<Header />
				<Switch>
					{getPlainRoutes().map(({ path, component: Component, exact }) => (
						<Route path={path} render={(props) => <Component {...props} />} exact={exact} key={path || '/404'} />
					))}
				</Switch>
				<Footer />
			</Router>
		</FirestoreProvider>
	);
}
